import type { RecipeImportDraft } from "@batch-and-bowl/shared";
import { ApiError, apiFetch } from "./client";

export async function extractRecipeFromUrl(url: string): Promise<RecipeImportDraft> {
  const { draft } = await apiFetch<{ draft: RecipeImportDraft }>(
    "/recipe-import/extract",
    { method: "POST", body: JSON.stringify({ url }) },
  );
  return draft;
}

// Multipart — bypasses apiFetch's forced JSON content-type (same pattern as ImageUpload).
export async function extractRecipeFromImage(file: File): Promise<RecipeImportDraft> {
  const formData = new FormData();
  formData.append("image", file);
  const response = await fetch("/api/backend/recipe-import/extract", {
    method: "POST",
    body: formData,
    credentials: "include",
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new ApiError(data.error || "Import failed", response.status, data);
  }
  return (data as { draft: RecipeImportDraft }).draft;
}
